import React, { useEffect, useState } from "react";
import { bool, func } from "prop-types";

const SideMenu = ({ open, setOpen }) => {
  const [productOpen, setProductOpen] = useState(false);
  const [professionalOpen, setProfessionalOpen] = useState(false);
  const [resourceOpen, setResourceOpen] = useState(false);

  useEffect(() => {
    // Disable scroll while side menu is open.
    if (open) {
      document.body.style.overflow = "hidden";
    }

    return () => (document.body.style.overflow = "unset");
  });

  const handleSideMenuOpen = (open) => {
    setOpen(!open);
    setProductOpen(false);
    setProfessionalOpen(false);
    setResourceOpen(false);
  };

  const handleDropdownOpen = (dropdownItemClicked) => {
    setProductOpen(false);
    setProfessionalOpen(false);
    setResourceOpen(false);

    switch (dropdownItemClicked) {
      case "product":
        setProductOpen(!productOpen);
        break;
      case "professional":
        setProfessionalOpen(!professionalOpen);
        break;
      case "resource":
        setResourceOpen(!resourceOpen);
        break;
      default:
        setProductOpen(false);
        setProfessionalOpen(false);
        setResourceOpen(false);
        break;
    }
  };

  return (
    <div className="side-menu" style={{transform: open ? 'translateX(-100%)' : 'translateX(0)' }}>
      <a
        href="/"
        onClick={() => handleSideMenuOpen(open)}
      >
        Home
      </a>
      <div>
        <button onClick={() => handleDropdownOpen("product")}>Product</button>
        <div style={{ display: productOpen ? "block" : "none" }}>
          <a href="/products/bluebox">BlueBox</a>
          <a href="/products/asthmagram">Asthmagram</a>
        </div>
      </div>
      <div>
        <button onClick={() => handleDropdownOpen("professional")}>
          Professional
        </button>
        <div style={{ display: professionalOpen ? "block" : "none" }}>
          <a href="code_blue" onClick={() => handleSideMenuOpen(open)}>
            Code Blue
          </a>
          <a href="asthma_care" onClick={() => handleSideMenuOpen(open)}>
            Asthma Care
          </a>
        </div>
      </div>
      <div>
        <button onClick={() => handleDropdownOpen("resource")}>Resource</button>
        <div style={{ display: resourceOpen ? "block" : "none" }}>
          <a href="#" onClick={() => handleSideMenuOpen(open)}>
            AHA
          </a>
          <a href="#" onClick={() => handleSideMenuOpen(open)}>
            AAAAI
          </a>
          <a href="#" onClick={() => handleSideMenuOpen(open)}>
            NIH
          </a>
        </div>
      </div>
      <a href="" onClick={() => handleSideMenuOpen(open)}>
        News
      </a>
      <a href="/about-us" onClick={() => handleSideMenuOpen(open)}>
        About Us
      </a>
      <a href="/contact-us" onClick={() => handleSideMenuOpen(open)}>
        Contact Us
      </a>
    </div>
  );
};

SideMenu.propTypes = {
  open: bool.isRequired,
  setOpen: func.isRequired,
};

export default SideMenu;
